// import { customAxios, IDUSUARIO, FDV_URL } from '../constants';

export default function(pedido) {
  const data = {
    // numPedidoVeh: pedido.numPedidoVeh,
    // codCia: pedido.codCia,
    // codProv: pedido.codProv,
    // numProfVeh: proformaID,
    carrocero: pedido[0] ? pedido[0].format('DD/MM/YYYY') : '',
    pdi: pedido[1] ? pedido[1].format('DD/MM/YYYY') : '',
    entrega: pedido[2] ? pedido[2].format('DD/MM/YYYY') : '',
  };

  // const config = {
  //   headers: {
  //     idUsuario: IDUSUARIO,
  //   },
  // };

  // return customAxios.post(`${FDV_URL}/...`, data, config);
  console.log(data);
}



// WEBPACK FOOTER //
// ./src/utils/applyDates.js